import {  WhatsAppOutlined } from "@ant-design/icons";

type EmailWhatsappTextProps = {
  value: string | number;
  type: "whatsapp" | "email";
};

export const EmailWhatsappText = ({ value, type }: EmailWhatsappTextProps) => {
  return type === "whatsapp" ? (
    <a
      href={`https://api.whatsapp.com/send/?phone=${value}`}
      target="_blank"
      className="!text-primary flex items-center max-w-fit gap-1 hover:opacity-90"
    >
      <WhatsAppOutlined />
      {value}
    </a>
  ) : type === "email" ? (
    <a
      href={`mailto:${value}`}
      target="_blank"
      className="!text-primary flex items-center max-w-fit gap-1 hover:opacity-90"
    >
      {value}
    </a>
  ) : (
    ""
  );
};
